module.exports = __webpack_public_path__ + "static/media/instagram.c58a61e9.svg";